
  import { mapEntityProperties } from '@/utils/mapEntityProperties'
  import { JobEntity } from '../../domain/entities/JobEntity'
  export class JobModel extends JobEntity {
  constructor(dataDto) {
    super()
    mapEntityProperties(this, dataDto)
  }
}